import React, { useState } from 'react'
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";
import "./brand-data.scss";

import { Grid } from '@mui/material';
import { SortingColumnsType } from '../../../components/table-component/table';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { TableComponentBrandPulse } from '../../../components/table-component/common-table-brand-pulse';
import { Methods } from '../../../core/utility';


interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  detailedInfluencer: any;
  onTabSelect?: any
  title?: string;
  isOpen: boolean;
  onToggle?: any;
  noData: boolean;
  loader: boolean;
  insight: any
}

const methods = new Methods()

// For image tab
const columnDisplayNamePostsImage = {
  user_posted: "Name",
  followers: "Followers",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)",
};

const sortingColumnTypePostImage: SortingColumnsType[] = [
  { name: "Name", columnSize: "180px" },
  { name: "er", columnSize: "70px" },
  { name: "likes", columnSize: "100px" },
  { name: "comments", columnSize: "130px" },
  {
    name: "amount",
    columnSize: "120px",
  },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];

// For video tab
const columnDisplayNamePostsVideo = {
  user_posted: "Name",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  video_plays: "Video Views",

  amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)",
};

const sortingColumnTypePostVideo: SortingColumnsType[] = [
  { name: "Name", columnSize: "180px" },
  { name: "er", columnSize: "70px" },
  { name: "likes", columnSize: "100px" },
  { name: "comments", columnSize: "130px" },
  { name: "video_plays", columnSize: "120px" },
  {
    name: "amount",
    columnSize: "120px",
  },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];


const columnDisplayNameInfluencers = {
  // user_posted: "Influencer",
  // total_posts: "Post",
  // er: "ER",
  // likes: "Likes",
  // video_views: "Views",
  // comments: "Comments",
  user_posted: "Influencer",
  avg_followers: "Followers",
  total_posts: "Post",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  // video_views: "Views",
  amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)"

};

const sortingColumnTypeInfluencer: SortingColumnsType[] = [
  {
    name: "user_posted",
    columnSize: "180px",
  },
  {
    name: "avg_followers",
    columnSize: "100px",
  },
  
  {
    name: "total_posts",
    columnSize: "70px",
  },
  {
    name: "er",
    columnSize: "70px",
  },
  {
    name: "likes",
    columnSize: "100px",
  },
  {
    name: "comments",
    columnSize: "100px",
  },

  {
    name: "amount",
    columnSize: "120px",
  },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
];
const columnDisplayNameInfluencersVideo = {
  user_posted: "Influencer",
  avg_followers: "Followers",
  total_posts: "Post",
  er: "ER",
  likes: "Likes",
  comments: "Comments",
  video_plays: "Views",
  amount: "Amount Spent in (INR)",
  emv_total: "EMV in (INR)" 
};

const sortingColumnTypeInfluencerVideo: SortingColumnsType[] = [
  {
    name: "user_posted",
    columnSize: "180px",
  },
  {
    name: "avg_followers",
    columnSize: "100px",
  },
  
  {
    name: "total_posts",
    columnSize: "70px",
  },
  {
    name: "er",
    columnSize: "70px",
  },
  {
    name: "likes",
    columnSize: "100px",
  },
  {
    name: "comments",
    columnSize: "100px",
  },
  {
    name: "video_plays",
    columnSize: "130px",
  },
  {
    name: "amount",
    columnSize: "120px",
  },
  {
    name: "emv_total",
    columnSize: "80px",
  },
  
  
];
const keyInsightData = [
  {
    id: "1",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "2",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "3",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "4",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
  {
    id: "5",
    value: "🔥 Highest Engagement Rate: Micro Influencers (10K - 50K) lead with a 6% ER."
  },
]


  
function capitalize(str: any) {
  return typeof str === "string" ? str.charAt(0).toUpperCase() + str.slice(1) : "";
}

const insightsConfig = [
  {
    icon: "📸",
    label: "Content Format Winner",
    generate: (data: any) => {
      const type = data?.content_format?.[0]?.content;
      const er = data?.content_format?.[0]?.average_er;

      return type && er > 0 ? (
        <>
          <strong>{capitalize(type)}s</strong> outperformed others with{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`}</strong>{" "}
          average ER.
        </>
      ) : null;
    }
  },
  {
    icon: "💡",
    label: "Best ROI",
    generate: (data: any) => {
      const name = data?.roi_format?.[0]?.fullname;
      const ratio = data?.roi_format?.[0]?.emv_ratio;
    
      return name && ratio > 0 ? (
        <>
          <strong>{name}</strong> delivered the highest EMV-to-spend ratio at{" "}
          <strong>{ratio > 1 ? `${ratio.toFixed(0)}x` : `${ratio.toFixed(1)}x`}</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "🚀",
    label: "Top Performing Post",
    generate: (data: any) => {
      const post = data?.top_performing_post?.[0];
      const er = post?.er;

      return post && post.video_plays > 0 ? (
        <>
          <strong>{post.fullname}'s</strong>{" "}
          <strong>{post.content_type.toLowerCase()}</strong> drove the most
          traction with <strong>{methods.convertExactNumber(post.video_plays)} views</strong> and{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`} ER</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "🔄",
    label: "Most Engaging Post Type",
    generate: (data: any) => {
      const type = data?.content_format?.[0]?.content;
      const er = data?.content_format?.[0]?.average_er;

      return type && er > 0 ? (
        <>
          <strong>{capitalize(type)}s</strong> outperformed others with an average{" "}
          <strong>{er > 1 ? `${er.toFixed(2)}%` : `${er.toFixed(2)}%`}</strong>{" "}
          ER.
        </>
      ) : null;
    }
  },
  {
    icon: "🧵",
    label: "Highest Volume by Type",
    generate: (data: any) => {
      const type = data?.highest_volume?.[0]?.normalized_content_type;
      const emvTotal = data?.highest_volume?.[0]?.["AVG(emv_total)"];
  
      return type && emvTotal > 0 ? (
        <>
          <strong>{capitalize(type)} posts</strong> were higher in quantity, but video posts drove{" "}
          <strong>{emvTotal > 1 ? `${emvTotal.toFixed(0)}x` : `${emvTotal.toFixed(1)}x`}</strong> more EMV.
        </>
      ) : null;
    }
  },
  {
    icon: "💬",
    label: "Most Commented Content",
    generate: (data: any) => {
      const commentData = data?.commented_data?.[0];
      return commentData && commentData.comments > 0 ? (
        <>
          <strong>
            {commentData.fullname}'s {commentData.content_type.toLowerCase()}
          </strong>{" "}
          post saw the highest comment volume of{" "}
          <strong>{methods.convertExactNumber(commentData.comments)}</strong>.
        </>
      ) : null;
    }
  },
  {
    icon: "❤️",
    label: "Most Liked Post",
    generate: (data: any) => {
      const likeData = data?.liked_post_data?.[0];
      return likeData && likeData.likes > 0 ? (
        <>
          <strong>
            {likeData.fullname}'s {likeData.content_type.toLowerCase()} received
          </strong>{" "}
          <strong>{methods.convertExactNumber(likeData.likes)} likes</strong>, the highest across all content.
        </>
      ) : null;
    }
  }
];

const DetailedInfluencerAnalyticsPaid: React.FC<Props> = (props: Props) => {
  const [renderData, setRenderData] = useState<any>([]);
  const [selectedMainTab, setSelectedMainTab] = useState("influencer"); // default
  const [key, setKey] = useState("video"); // inner tab
  const filteredData = props?.detailedInfluencer || [];
  const handleSelect = (mainKey: any) => {
    setSelectedMainTab(mainKey);
    props.onTabSelect(mainKey, key); 
  };
  const handleInnerSelect = (innerKey: any) => {
    setKey(innerKey);
    props.onTabSelect(selectedMainTab, innerKey);
  };


const isEmptySnapshot = Object.values(props?.insight || {}).every(
  (arr) => Array.isArray(arr) && arr.length === 0
);


  return (
    <div className='engg-snapshot-data-inner-tab-content'>
      <Tab.Container defaultActiveKey="influencer">
        <Grid className='key-insight-list-container' item xs={12} md={12} lg={8} xl={8}>
          
          
            {/* {keyInsightData?.map((data: any) => {
              return <li>{data?.value}</li>
            })} */}
            
            {/* {insightsConfig?.map((insight, index) => {
              const text = insight?.generate(insightData); // Pass the single object
              return text ? (
                <li key={index}>
                  {insight.icon} <strong>{insight.label}</strong>: {text}
                </li>
              ) : null;
            })} */}
            {!isEmptySnapshot && 
              <><strong>Key Insights:</strong> 
              <ul className='key-insight-list'>
                {insightsConfig.map((insight, index) => {
                  const text = insight.generate(props?.insight || {});
                  return text ? (
                    <li key={index}>
                      <span>{insight.icon} {insight.label}</span> : {text}
                    </li>
                  ) : null;
                })}
              </ul>
              </>
            }
            

          
        </Grid>
        <Nav className='engg-snapshot-data-nested-tab' onSelect={handleSelect} >
          <Nav.Item>
            <Nav.Link eventKey="influencer" className='detailed-infl-tab'>By Influencers</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="brands" className='detailed-infl-tab'>By Posts</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content className='position-relative infl-analytics-tabs'>
        <div className="infl-inner-switch-toggle">
          <div className="labels-row">
            <span  onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')} className={`label ${key === 'video' ? 'active-label' : ''}`}>Videos</span>
            <span onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')} className={`label ${key === 'image' ? 'active-label' : ''}`}>Static</span>
          </div>
          <div className="switch-container" onClick={() => handleInnerSelect(key === 'image' ? 'video' : 'image')}>
            <div className={`switch-slider ${key}`} />
          </div>
        </div>
          <Tab.Pane eventKey="brands">
            <Tabs
            activeKey={key}
            onSelect={(k: any) => handleInnerSelect(k)}
            className='infl-inner-tab'
            
          >
            <Tab
              eventKey="video"
              title=""
              className='comment-tab-content'>
                <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
                  <TableComponentBrandPulse className=''
                    pagination={true}
                    columnDisplayName={columnDisplayNamePostsVideo}
                    inputDataSource={filteredData}
                    selectedMainTab={selectedMainTab}
                    orderByColumnName=""
                    sortingColumnType={sortingColumnTypePostVideo}
                    renderData={renderData}
                    noData={props?.noData}
                    loader={props?.loader}
                    setRenderData={(e: any) => setRenderData(e)}
                  />
                  
              </div>
            </Tab>
            <Tab
              eventKey="image"
              title=""
              className='comment-tab-content'>
                  <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
              <TableComponentBrandPulse
                pagination={true}
                columnDisplayName={columnDisplayNamePostsImage}
                inputDataSource={filteredData}
                selectedMainTab={selectedMainTab}
                orderByColumnName=""
                sortingColumnType={sortingColumnTypePostImage}
                renderData={renderData}
                loader={props?.loader}
                setRenderData={(e: any) => setRenderData(e)}
                noData={props?.noData}
              />
              
              </div>
            </Tab>
          </Tabs>
          </Tab.Pane>
          <Tab.Pane eventKey="influencer"><Tabs
            activeKey={key}
            className="infl-inner-tab"
            onSelect={(k: any) => handleInnerSelect(k)}
          >
            <Tab
              eventKey="video"
              title="Videos"
              className='comment-tab-content'>
                  <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
              <TableComponentBrandPulse
                pagination={true}
                columnDisplayName={columnDisplayNameInfluencersVideo}
                inputDataSource={filteredData}
                selectedMainTab={selectedMainTab}
                orderByColumnName=""
                sortingColumnType={sortingColumnTypeInfluencerVideo}
                renderData={renderData}
                setRenderData={(e: any) => setRenderData(e)}
                noData={props?.noData}
                loader={props?.loader}
              />
                </div>
            </Tab>
            <Tab
              eventKey="image"
              title="Static"
              className='comment-tab-content'>
                  <div className='brand-pulse-influencer-details-table table-spacing-lg bdr-rad-0'>
              <TableComponentBrandPulse
                pagination={true}
                columnDisplayName={columnDisplayNameInfluencers}
                inputDataSource={filteredData}
                orderByColumnName=""
                selectedMainTab={selectedMainTab}
                sortingColumnType={sortingColumnTypeInfluencer}
                renderData={renderData}
                setRenderData={(e: any) => setRenderData(e)}
                noData={props?.noData}
                loader={props?.loader}
              />
              </div>
                
            </Tab>
          </Tabs></Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(DetailedInfluencerAnalyticsPaid);

export { connectToRedux as DetailedInfluencerAnalyticsPaid };

